import { Branch, Brand } from "../../../interfaces/types";

export interface Catalogue {
  branch: Branch;
  link: string;
}

export interface BrandMenuObject {
  name: Brand;
  title: string;
  tags?: string[];
  catalogueList?: Catalogue[];
}

export const allBrands: BrandMenuObject[] = [
  {
    name: "direct-group",
    title: "Direct Group",
  },
  {
    name: "hve",
    title: "High Vis Everywhere",
  },
  {
    name: "good-mates",
    title: "GOODMATES",
  },
  {
    name: "biz-collection",
    title: "Biz Collection",
    tags: [
      "polos",
      "tees",
      "shirts",
      "biz separates",
      "knitwear",
      "hoodies-fleece",
      "activewear",
      "jackets",
      "hospitality",
      "health",
      "clearance",
      "catalogue",
    ],
  },
  {
    name: "biz-corporates",
    title: "Biz Corporates",
    tags: [
      "tops",
      "shirts",
      "jackets",
      "vests",
      "pants",
      "skirts",
      "dresses",
      "culottes",
      "shorts",
      "knitwear",
      "outerwear",
      "blouses",
      "advatex",
      "coats",
      "accessories",
      "comfort wool stretch",
      "cool stretch plain",
      "boulevard",
      "siena suiting",
      "fabric packs",
      "clearance",
    ],
  },
  {
    name: "syzmik",
    title: "Syzmik",
    tags: [
      "syzmik-shirts",
      "syzmik-polos",
      "syzmik-tees",
      "pants",
      "shorts",
      "fleece-hoodies",
      "syzmik jackets",
      "vests",
      "overalls",
      "fire-armour",
      "clearance",
      "accessories",
    ],
  },
  {
    name: "inaura",
    title: "Inaura",
    tags: [
      "polos",
      "tops",
      "shirts",
      "tunics",
      "pants",
      "shorts",
      "skirts",
      "scrubs",
      "knitwear",
      "vests",
      "fleece",
      "jackets",
      "cardigans",
      "T-Tops",
      "pink products",
      "accessories",
      "clearance",
    ],
  },
];

export const transformName = (name: string) => {
  switch (name) {
    case "hoodies-fleece":
      return "Hoodies & Fleece";
    case "fleece-hoodies":
      return "Hoodies & Fleece";
    case "health":
      return "Health and Beauty";
    case "fire-armour":
      return "Fire Armour";
    case "syzmik-shirts":
      return "Shirts";
    case "syzmik-polos":
      return "Polos";
    case "syzmik-tees":
      return "Tees";
    default:
      return name;
  }
};
